import React from "react";

const ServicesSection = () => {
  return (
    <section className=" py-3 section services bg-light-primary">
      <div className="service-right">
        <img
          src="/img/bg/service-right.svg"
          className="img-fluid"
          alt="services right"
        />
      </div>

      <div className="container">
        {/* Heading */}
        <div className="section-heading" data-aos="fade-down">
          <h2>How SRS Cab Service Works</h2>
          <p>
            Booking your ride is quick and easy. Follow these simple steps to enjoy a safe and comfortable journey.
          </p>
        </div>

        {/* Services */}
        <div className="services-work">
          <div className="row">
            {/* Step 1 */}
            <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
              <div className="services-group">
                <div className="services-icon border-secondary">
                  <img
                    className="icon-img bg-secondary"
                    src="/img/icons/services-icon-01.svg"
                    alt="Choose Locations"
                  />
                </div>
                <div className="services-content">
                  <h3>1. Enter Your Trip Details</h3>
                  <p>
                    Select your pickup location, destination, date, and time. 
                    Whether it's a local ride or an outstation trip, we’ve got you covered.
                  </p>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
              <div className="services-group">
                <div className="services-icon border-warning">
                  <img
                    className="icon-img bg-warning"
                    src="/img/icons/services-icon-02.svg"
                    alt="Choose Car"
                  />
                </div>
                <div className="services-content">
                  <h3>2. Choose Your Cab</h3>
                  <p>
                    Browse from a range of clean and well-maintained vehicles. 
                    Pick the cab that suits your budget and travel needs.
                  </p>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="col-lg-4 col-md-4 col-12" data-aos="fade-down">
              <div className="services-group">
                <div className="services-icon border-dark">
                  <img
                    className="icon-img bg-dark"
                    src="/img/icons/services-icon-03.svg"
                    alt="Book your Car"
                  />
                </div>
                <div className="services-content">
                  <h3>3. Confirm & Enjoy Ride</h3>
                  <p>
                    Confirm your booking instantly and relax. 
                    Our professional driver will arrive on time to give you a safe and comfortable ride.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;